export const getEnvironment = (): string | undefined =>
    process.env.REACT_APP_ENV === 'production'
        ? ''
        : process.env.REACT_APP_ENV === 'development'
        ? 'develop'
        : process.env.REACT_APP_ENV;
